import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams } from '../../schema'

interface DeleteBoardArguments {
  params: OpalApiRequestParams<'DeleteBoardCollaboratorV3'>
}

// The delete endpoint does not return data,
// only a response with a `204` status code. Because
// of that, we will hard code `null` as the response
export async function deleteBoardCollaborator({
  params,
}: DeleteBoardArguments): Promise<null> {
  const url = new URL(
    `/board_collaborators/v3/${params.path.board_collaborator_id}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then(() => null)
}
